import request from '@/utils/request'

//搜索推荐列表
export function getList(data) {
    return request({
        url: '/backend/searchRecommend/get-list',
        method: 'get',
        data: data
    })
}

//获取类型关联内容列表接口
export function getRelationList(data) {
    return request({
        url: '/backend/searchRecommend/type-relation/list',
        method: 'post',
        data: data
    })
}

//创建/编辑
export function addRelation(data) {
    return request({
        url: '/backend/searchRecommend/type-relation/add',
        method: 'post',
        data: data
    })
}

//上下架
export function setUpDown(data) {
    return request({
        url: '/backend/searchRecommend/type-relation/set-up-down',
        method: 'post',
        data: data
    })
}

//排序
export function updateSort(data) {
    return request({
        url: '/backend/searchRecommend/type-relation/update-sort',
        method: 'post',
        data: data
    })
}

//删除
export function delRelation(data) {
    return request({
        url: '/backend/searchRecommend/type-relation/del',
        method: 'post',
        data: data
    })
}

//筛选咨询师列表
export function screenCounselorList(data) {
    return request({
        url: '/backend/searchRecommend/type-relation/screen-counselor-list',
        method: 'post',
        data: data
    })
}
